module.exports = __webpack_public_path__ + "static/media/Visit_insurance.26268060.svg";